import React from 'react';
import { ICON_STROKE } from '../../constants/icon-stroke';

/** Matches admin `apps/web/src/components/CustomIcons/GiftCardIcon.tsx`. */
interface GiftCardIconProps {
  size?: number;
  color?: string;
  className?: string;
  strokeWidth?: number;
}

const GiftCardIcon: React.FC<GiftCardIconProps> = ({
  size = 20,
  color = '#404040',
  className,
  strokeWidth = ICON_STROKE.standard,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
  >
    <path
      d="M9.99996 4.99996V18.3333M9.99996 4.99996H7.05353C6.6194 4.99996 6.20304 4.82436 5.89606 4.5118C5.58909 4.19924 5.41663 3.77532 5.41663 3.33329C5.41663 2.89127 5.58909 2.46734 5.89606 2.15478C6.20304 1.84222 6.6194 1.66663 7.05353 1.66663C9.3452 1.66663 9.99996 4.99996 9.99996 4.99996ZM9.99996 4.99996H12.9464C13.3805 4.99996 13.7969 4.82436 14.1039 4.5118C14.4108 4.19924 14.5833 3.77532 14.5833 3.33329C14.5833 2.89127 14.4108 2.46734 14.1039 2.15478C13.7969 1.84222 13.3805 1.66663 12.9464 1.66663C10.6547 1.66663 9.99996 4.99996 9.99996 4.99996ZM16.6666 9.16663V15.6666C16.6666 16.6 16.6666 17.0668 16.485 17.4233C16.3252 17.7369 16.0702 17.9918 15.7566 18.1516C15.4001 18.3333 14.9334 18.3333 14 18.3333L5.99996 18.3333C5.06654 18.3333 4.59983 18.3333 4.24331 18.1516C3.92971 17.9918 3.67474 17.7369 3.51495 17.4233C3.33329 17.0668 3.33329 16.6 3.33329 15.6666V9.16663M1.66663 6.33329L1.66663 7.83329C1.66663 8.3 1.66663 8.53336 1.75745 8.71162C1.83735 8.86842 1.96483 8.9959 2.12163 9.0758C2.29989 9.16663 2.53325 9.16663 2.99996 9.16663L17 9.16663C17.4667 9.16663 17.7 9.16663 17.8783 9.0758C18.0351 8.9959 18.1626 8.86842 18.2425 8.71162C18.3333 8.53336 18.3333 8.3 18.3333 7.83329V6.33329C18.3333 5.86658 18.3333 5.63323 18.2425 5.45497C18.1626 5.29817 18.0351 5.17068 17.8783 5.09079C17.7 4.99996 17.4667 4.99996 17 4.99996L2.99996 4.99996C2.53325 4.99996 2.29989 4.99996 2.12163 5.09079C1.96483 5.17068 1.83735 5.29817 1.75745 5.45497C1.66663 5.63323 1.66663 5.86658 1.66663 6.33329Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default GiftCardIcon;
